import angular from 'angular';
import { PortariaResponsavelForm } from '../../models/portaria.model';

export class PortariaParametrizacaoModalController {
  static $inject = ['$uibModalInstance', 'entity'];

  public form: angular.IFormController;
  public entityCopy: PortariaResponsavelForm;

  constructor(
    public $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
    public entity: PortariaResponsavelForm
  ) {
    this.entityCopy = angular.copy(this.entity);
  }

  ok() {
    this.form.$submitted = true;
    if (this.form.$invalid) {
        return;
    }
    this.$uibModalInstance.close(this.entityCopy);
  }

  close() {
    this.$uibModalInstance.dismiss('fechar');
  }
}
